// extracted by mini-css-extract-plugin
module.exports = {"events":"TimelineEvents_events__WcGpf","section":"TimelineEvents_section__2qf6O","currentEvent":"TimelineEvents_currentEvent__3Ty1n","nextEvent":"TimelineEvents_nextEvent__1sftR"};